import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink } from "../../../../redux/actions";
import {
  Row,
  Button,
  ButtonGroup,
  FormGroup,
  Form,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from "reactstrap";
import CustomModal from "../../../../components/utils/CustomModal";
import Field from "../../../../components/utils/Field"
import { Colxx } from "../../../../components/common/CustomBootstrap";
import CustomDropdown from "../../../../components/utils/CustomDropdown";
import Dialog from "../../../../components/utils/Dialog";
import DataTable from "../../../../components/utils/DataTable";
import _axios from "../../../../libs/axios";
import { NotificationManager } from "../../../../components/common/react-notifications";
import { connect } from "react-redux";
import modules from "../../../../config/admModules/modules";
import { cloneDeep, debounce } from "lodash"
import ReactToPrint from 'react-to-print';
import XLSX from 'xlsx-js-style';
import { objToQueryString, isAndroidOrIos } from "../../../../helpers/Utils"

class AdmGrades extends Component {
  constructor(props) {
    super(props);

    this.view = (() => {

      let m = modules.find((e) => { return e.path === this.props.match.path })
      
      let n = this.props.menuItems.find((e) => {
          return e.to === this.props.match.path
      });
      
      // look in submenus
      if (n === undefined) {
        this.props.menuItems.forEach(menu => {
          if (n === undefined && menu.subs && menu.subs.length > 0) {
            n = menu.subs.find((ee) => { return ee.to === this.props.match.path });
          }
        });
      }

      let  module = m.module(this)
      
      if (m && n) {
        n = { ...module, ...n }
        return n
      }
    })();

    this.state = {
      resource: null,
      data: [],
      progressBar: false,
      evalConcept: [],
      numLevels: 0,
      lastsConcepts: [],
      selectedArrow: 0,
      selectedReport: 0,
      
      periodId: null,
      superSectionId: null,
      sectionId: null,
      activityId: null,

      activityPartId: null,
      masterId: null,
      groupId: null,

      labelperiodId: '-',
      labelsuperSectionId: '-',
      labelsectionId: '-',
      labelactivityId: '-',
      labelmasterId: null,
      labelgroupId: null,

      sectionReloader: true,
      activityReloader: true,
      masterReloader: true,

      showTooltip: false,

      toggleGenericVisible:false,
      modalGeneric: { title:'', msg:''},

      ready: false,
      isBehavior: this.view.config && this.view.config.isBehavior,
      loadGrid: false,
      master: null,
      masterFace: null,
      modal: false,

      masters: [],
      mastersColumns: [],
      mastersRowCount: 0,
      mastersProgressBar: false,
      quantitativeGrades: [
        {value: "", label: "Sin nota"},
        {value: "0", label: "0"},
        {value: "1", label: "1"},
        {value: "2", label: "2"},
        {value: "3", label: "3"},
        {value: "4", label: "4"},
        {value: "5", label: "5"},
        {value: "6", label: "6"},
        {value: "7", label: "7"},
        {value: "8", label: "8"},
      ]
    };
  }

  defaultFilter () {
    this.setState({
      selectedReport: this.state.isBehavior ? 4 : 2,
      periodId: { value: "0", label: "[Actual]" }
    }, () => {
      this.setState({ ready: true })
    })
  }

  UNSAFE_componentWillMount() {
    if (this.props.deepLink) {
      // console.log(this.props.deepLink.params)
      this.setState({
        selectedReport: 5,
        periodId: { value: "0", label: "[Actual]" },
        superSectionId: this.props.deepLink.params[0],
        activityId: this.props.deepLink.params[1],
      }, () => {
        this.setState({ ready: true })
      })
    } else {
      // if (this.view.config && this.state.isBehavior) this.defaultFilter()
      // else this.getDefaultFilters()
      this.getDefaultFilters()
    }
  }

  componentDidMount() {
    window.onscroll = () => { this.scrollY() }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedReport !== this.state.selectedReport) {
       switch (this.state.selectedReport)
       {
         case 1: this.setState({ data: [],superSectionId: null,sectionId: null,activityId: null,activityPartId: null,masterId: null}); break; // masters
         case 8: this.setState({ data: [],sectionId: null,activityId: null, activityPartId: null,masterId: null,superSectionId: null}); break; // by group
         case 9: this.setState({ data: [],sectionId: null,activityId: null, activityPartId: null,masterId: null,superSectionId: null}); break; // by group descriptive conclusions
         default: this.setState({ data: [],sectionId: null,activityId: null, activityPartId: null,masterId: null}); break; // rest
       }
    }
  }

  componentWillUnmount() {
    this.view = null
    window.onscroll = null
    this.props.setDeeplink(null)
  }

  getDefaultFilters() {
    _axios
      .get('admGrades/defaultFilters')
      .then(r => {
        if (r.status >= 0) {
          if (!r.data) {
            this.defaultFilter()
            return
          }
          this.setState({
            ready: true,
            selectedReport: this.state.isBehavior ? 4 : (r.data.selectedReport || 2),
            periodId: r.data.periodId || null,
            superSectionId: r.data.superSectionId || null         
          }, () => {
            this.setState({ sectionId: r.data.sectionId || null, activityId: r.data.activityId || null })
          })
        } else NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
      })
  }

  getEvalConcept(clearable = true) {
    this.setState({ progressBar: true });
    if (clearable) this.setState({ data: [] });
    let path = ''
    const {activityId, periodId, sectionId, selectedReport, activityPartId, groupId} = this.state

    if (this.state.isBehavior) {
      if (selectedReport === 8) {
        path = '/admEvalConcept/getHeaderFinal/behavior?periodId=' + periodId + '&sectionId='+ (sectionId || -1) +'&levelCount=1&isBehavior=true&groupId=' + groupId
      } else if (selectedReport === 9) {
        path = '/admEvalConcept/getHeaderFinal/behavior?periodId=' + periodId + '&sectionId='+ (sectionId || -1) +'&levelCount=1&isBehavior=true&type=2&groupId=' + groupId
      } else {
        path = '/admEvalConcept/getHeaderFinal' + (this.state.isBehavior ? '/behavior' :'')+'?periodId=' + periodId + '&sectionId='+ (sectionId || -1) +'&levelCount=1&isBehavior=true' + (selectedReport === 3 ? '&type=4':'') + (groupId ? ('&groupId=' + groupId) : '')
      }
    } else {
      path = 'admEvalConcept/getHeader/?PageSize=40&activityId='+ (activityId||activityPartId) + (activityPartId ? '&isPart=true':'') + (sectionId ? ('&sectionId='+sectionId):'') + '&page=1'+ (selectedReport === 6 ? '&levelCount=1&type=2':'')
      if (selectedReport === 3) path = 'admEvalConcept/getHeaderFinal' + (this.state.isBehavior ? '/behavior' :'') + '?periodId='+ periodId +'&sectionId=' + (sectionId || -1) + '&levelCount=0' + (groupId ? ('&groupId=' + groupId) : '')
      else if (selectedReport === 4) path = 'admEvalConcept/getHeaderFinal' + (this.state.isBehavior ? '/behavior' :'') + '?periodId='+ periodId +'&sectionId=' + (sectionId || -1) + '&levelCount=-1' + (groupId ? ('&groupId=' + groupId) : '')
      else if (selectedReport === 8) path = 'admEvalConcept/getHeader/?PageSize=40&activityId='+ activityId + '&groupId=' + groupId + '&page=1'
      else if (selectedReport === 9) path = 'admEvalConcept/getHeader/?PageSize=40&activityId='+ activityId + '&groupId=' + groupId + '&page=1&levelCount=1&type=2'
    }
    
    _axios
      .get(path)
      .then(r => {
        if (r.status >= 0) {
          if (!r.data || r.data.length === 0) {
            this.setState({ progressBar: false });
            return NotificationManager.error("No hay conceptos de evaluación", 'Opps', 5000, null, null, 'outline')
          }

          let order = []
          var maxLevel = Math.max.apply(Math, r.data.map(function(o) { return o.level; }));
          // ordeno el array segun level
          for(let i = 0; i<=maxLevel; i++) {
            order = order.concat(r.data.filter((e) => { return e.level === i }).sort((a, b) => { return a.order - b.order })) // ordeno segun order
          }

          // ordenar segun jerarquía
          let res = []
          let index = 0
          res = order.filter(e => e.parentId === null)
          /*
          const parentsId = res.map(p => { p = p.ID; return p })
          const childrenConcepts = order.filter(o => parentsId.indexOf(o.parentId) > -1)
          const totalConcepts = parentsId.length + childrenConcepts.length
          console.log(parentsId)
          console.log(childrenConcepts)
          console.log(totalConcepts)
          */

          if (res.length > 0) {
            let f = () => {
              if (res.length === order.length) return
              order.forEach((e) => {
                if (e.parentId === res[index].ID) res.splice(index + (res.filter(e => e.parentId === res[index].ID).length + 1), 0, e)
              });
              index++
              f()
            }
            f()
          }

          // obtengo a los ultimos conceptos de cada jerarquía
          let lasts = []
          res.forEach(e => {
            if (res.findIndex(d => d.parentId === e.ID) < 0) lasts.push(e)
          });

          this.setState({ evalConcept: res, lastsConcepts: lasts }, () => {
            // console.log(this.state.lastsConcepts)
            this.getData(clearable)
          });
        } else NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
        // this.setState({ progressBar: false });
      })
  }

  getData(clearable = true) {
    this.setState({ progressBar: true });
    if (clearable) this.setState({ loadGrid: false });
    let path = ''
    const {activityId, periodId, sectionId, selectedReport, activityPartId, groupId} = this.state

    if (this.state.isBehavior) {
      if (selectedReport === 8 || selectedReport === 9) {
        path = '/admGrades/getFinal?periodId='+ periodId +'&sectionId=' + (sectionId || -1) + '&levelCount=1&isBehavior=true&groupId=' + groupId
      } else {
        path = '/admGrades/getFinal?periodId='+ periodId +'&sectionId=' + (sectionId || -1) + '&levelCount=1&isBehavior=true' + (selectedReport === 3 ? '&type=4':'') + (groupId ? ('&groupId=' + groupId) : '')
      }
    } else {
      path = 'admGrades/get?activityId='+ (activityId || 0) + '&activityPartId=' + activityPartId + '&periodId=' + periodId + (sectionId ? ('&sectionId=' + sectionId) : '')
      if (selectedReport === 3) path = 'admGrades/getFinal?periodId=' + periodId + '&sectionId=' + sectionId + '&levelCount=0'
      else if (selectedReport === 4) path = 'admGrades/getFinal?periodId=' + periodId + '&sectionId=' + sectionId + '&levelCount=-1'
      else if (selectedReport === 8) path = 'admGrades/get?activityId='+ activityId + '&groupId=' + groupId + '&periodId=' + periodId
      else if (selectedReport === 9) path = 'admGrades/get?activityId='+ activityId + '&groupId=' + groupId + '&periodId=' + periodId
    }

    _axios
      .get(path)
      .then(r => {
        if (r.status >= 0) {
          if (!r.data || r.data.length === 0) {
            this.setState({ progressBar: false });
            return NotificationManager.error("No hay alumnos", 'Opps', 5000, null, null, 'outline')
          }
          let temp = cloneDeep(r.data)
          let lc = cloneDeep(this.state.lastsConcepts)
          let tempGrades = []

          lc.forEach((e, i) => {
            // if (i === 1 ) e.canEdit = false
            let n = {
              abrev: e.abrev,
              conceptId: e.ID,
              studentId: "",
              gradeNum: "",
              gradeTxt: "",
              type: e.type,
              parentId: e.parentId,
              locked: e.locked,
              qualifications: (() => {
                let r = []
                r.push({value: '', label: 'Sin nota'})
                if (e.qualifications) {
                  let p = e.qualifications.split(',')
                  p.forEach(e => { r.push({value: e, label: e}) });
                }
                return r
              })(),
              canEdit: e.canEdit,
              calcAverage: e.calcAverage
            }
            tempGrades = [...tempGrades, n]
          });

          temp.forEach(e => {
            e.grades = cloneDeep(tempGrades)
          });

          temp.forEach((e, index) => {
            e.grades.forEach((ee, index2) => {
              let o = r.data[index].grades.find(g => g.conceptId === ee.conceptId)
              if (o) temp[index].grades[index2] = {...temp[index].grades[index2], ...o}
            });
          });

          this.setState({ showTooltip: false })
          this.setState({ data: temp }, () => {
            // console.log(this.state.data)
            this.createHeader()
            setTimeout(() => { this.setState({loadGrid: true}) }, 1000)
          });
        } else NotificationManager.error(r.msg, 'Error', 5000, null, null, 'outline')
        this.setState({ progressBar: false });
      })
  }

  edit(items) {
    let grades = []
    items.forEach(item => {
      const {conceptId, studentId, type} = item.params
      grades.push(
        {
          conceptId: conceptId,
          studentId: studentId,
          gradeNum: type === 0 ? (item.val === "" ? null : item.val) : undefined,
          gradeTxt: type > 0 ? (item.val === "" ? null : item.val) : undefined
        }
      )
    });

    let body = {
      grades: grades
    }
    _axios
      .post('admGrades' + (this.state.isBehavior ? '/behavior' :''), body)
      .then(r => {
        if (r.status >= 0) {
          let d = cloneDeep(this.state.data)

          items.forEach(item => {
            const {conceptId, studentId, type, parentId, calcAverage} = item.params
            let f = d.find(e => e.studentId === studentId)
            if (f) {
              let n = f.grades.find(e => e.conceptId === conceptId)
              if (type === 0) n.gradeNum =  item.val === '' ? null : parseInt(item.val, 10)
              if (type > 0) n.gradeTxt = item.val
              // f.grades.map(g => {
              //   if (g.parentId === parentId) g.sync = true
              //   return g
              // })
              if (calcAverage) {
                f.grades.map(g => {
                  if (g.parentId === parentId) g.sync = true
                  return g
                })
              }
            }
          });

          this.setState({data: d})
        } else NotificationManager.error(r.msg, 'No se guardó la nota!', 10000, null, null, 'outline')
      })
      .catch((e) => { })
  }

  beforeEdit (e) {
    // console.log('beforeEdit', e.value)
    if (e.value === undefined || e.value === null) return
    const {conceptId, studentId, type} = e.params
    // const {type} = e.params
    const val = e.value

    // type input
    if (type === 0) {
      let num = parseInt(val, 10)
      if (num < 0 || num > 8) return
    }

    // type select
    /*
    if (type !== 0) {
      if (val.length > 1 ) return
    }
    */

    
    let f = this.state.data.find(e => e.studentId === studentId)
    if (f) {
      let n = f.grades.find(e => e.conceptId === conceptId)
      if (type === 0 && n.gradeNum === parseInt(val, 10)) return
      if (type === 1 && n.gradeTxt === val) return
      if ((type === 2 || type === 4) && n.gradeTxt === val) return
    }

    this.edit([{val: e.value, params: e.params}])
  }

  onChangeField = (e) => {
    if (e.value === undefined || e.value === null) return
    const { value, params } = e;
    const [fieldName, parentIndex, index] = params.inputId.split("-");
    // console.log(params)
  
    let intParentIndex = parseInt(parentIndex, 10);
    let intIndex = parseInt(index, 10);
    let intValue = parseInt(value, 10);

    // save last field automatically
    if (intParentIndex === (this.state.data.length -1) && intIndex === (this.state.lastsConcepts.length - 1) && [2,4].indexOf(params.type) === -1 && this.state.loadGrid) {
      return this.edit([{val: e.value, params: e.params}])
    }

    // if (this.state.loadGrid) {
    //   console.log(params)
    //   this.state.data.forEach((e) => {
    //     if (e.studentId === params.studentId) {
    //       e.grades.forEach((grade) => {
    //         if (grade.parentId === params.parentId && grade.locked) {
    //           // console.log("sync")
    //           grade.sync = true;
    //         }
    //       });
    //     }
    //   });
    // }
  
    if ((value.length === 1 && params.type === 0) || (params.type === 1 && (value.length >= 1 || value === ''))) {
      if (params.type === 0 && (intValue < 0 || intValue > 8)) {
        NotificationManager.error('Solo se permite igresar números del 0 al 8', "Error", 5000, null, null, 'outline')
        return
      }

      if (intIndex < this.state.lastsConcepts.length && intParentIndex < this.state.data.length) {

        /*
        // focus horizontal
        if (intIndex === (this.state.lastsConcepts.length - 1)) {
          intParentIndex = intParentIndex + 1
          intIndex = 0
        } else intIndex = intIndex + 1
        */

        // focus vertical
        if (intParentIndex === (this.state.data.length - 1)) {
          intParentIndex = 0
          intIndex = intIndex + 1
        } else intParentIndex = intParentIndex + 1
        
        const nextfield = document.querySelector(
          '#grades-'+fieldName+'-'+intParentIndex+'-'+(intIndex)
        );

        if (nextfield !== null) {
          if (isAndroidOrIos()) this.beforeEdit(e)
          if(this.state.loadGrid) nextfield.focus();
        } else {
          if (this.state.loadGrid) {
            this.edit([{val: e.value, params: e.params}])
          }
        }
      }
    }
  }

  onBlurField = (e) => {
    if (isAndroidOrIos()) return
    // console.log('blur', e)
    this.beforeEdit(e)
  }

  onKeyUpField = (e, ctx) => {
    let value = parseInt(e.target.value)
    if(typeof value === 'number') {
      if (value < 0 || value > 8) ctx.setState({[ctx.props.name]: ''})
    } else ctx.setState({[ctx.props.name]: ''})
  }


  execute = debounce(() => { this.getEvalConcept() }, 300)

  onChangeFieldFilter = (name, value) => {
    this.setState({data:[]});
    if (!value) return
    this.setState({[name]: value.value, ['label'+name]: value.label}, () => {
      
      if (value.value
        && (
        (name === 'sectionId' && (this.state.selectedReport === 3 || this.state.selectedReport === 4))
        || (name === 'sectionId' && this.state.activityId && (this.state.selectedReport === 2 || this.state.selectedReport === 6))
        || (name === 'activityId' && (this.state.selectedReport === 2 || this.state.selectedReport === 6))
        || (name === 'activityPartId' && this.state.selectedReport === 1)
        || (name === 'sectionId' && this.state.selectedReport === 5)
        || (name === 'groupId' && [8,9].indexOf(this.state.selectedReport) > -1 && (this.state.activityId || this.state.isBehavior))
        || (name === 'activityId' && [8,9].indexOf(this.state.selectedReport) > -1 && this.state.groupId)
        )
      ) this.execute()
    })
  }

  createHeader = () => {
    // console.log(this.state.lastsConcepts)
    const addName = (concept) => {
      const n = this.state.lastsConcepts.find(e => e.ID === concept.ID)
      return '<span class="truncate px-2">'+(n ? concept.abrev : concept.name)+'</span>'
    }

    document.getElementById('notas-header').innerHTML = '';
    let data = this.state.evalConcept
    let order = []
    var maxLevel = Math.max.apply(Math, data.map(function(o) { return o.level; }));
    this.setState({numLevels: (maxLevel + 1)})
    let lasts = []
    // ordeno el array segun level
    for(let i = 0; i<=maxLevel; i++) {
      order = order.concat(data.filter((e) => { return e.level === i }).sort((a, b) => { return a.order - b.order })) // ordeno segun order
      lasts.push(order[order.map(e => e.level).lastIndexOf(i)].ID)
    }

    // console.log(lasts)
    // console.log(order)

    // ordenar segun jerarquía
    let r = []
    let index = 0
    r = order.filter(e => e.parentId === null)

    // create header
    let h = document.createElement('div');
    h.className = 'notas-row'
    // create firsts columns
    r.forEach(e => {
      let i = document.createElement('div')
      i.className = 'notas-col' + (e.type === 2 || e.type === 4 ? ' type-descriptive' : '')
      i.id = e.ID
      let n = document.createElement('div')
      n.className = 'notas-name'
      n.id = 'nn-' + e.ID
      if (lasts.indexOf(e.ID) > -1) n.classList.add('notas-last-child')
      setTimeout(() => { n.style.width = n.offsetWidth + 'px' }, 100)
      setTimeout(() => { n.innerHTML = addName(e) }, 200)
      // n.append(e.abrev)
      i.appendChild(n)
      h.appendChild(i)
    });

    document.getElementById('notas-header').appendChild(h)
    
    if (r.length > 0) {
      let f = () => {
        if (r.length === order.length) {
          this.setState({ showTooltip: true })
          return
        }
          order.forEach((e) => {
            if (e.parentId === r[index].ID) {
              r.splice(index + (r.filter(e => e.parentId === r[index].ID).length + 1), 0, e)
              let p = document.getElementById(r[index].ID)
              if (p && p.childElementCount === 1) {
                // create new row
                let nr = document.createElement('div')
                nr.className = 'notas-row'
                // create new col
                let i = document.createElement('div')
                i.className = 'notas-col' + (e.type === 2 || e.type === 4 ? ' type-descriptive' : '')
                i.id = e.ID
                let n = document.createElement('div')
                n.className = 'notas-name'
                n.id = 'nn-' + e.ID
                if (lasts.indexOf(e.ID) > -1) n.classList.add('notas-last-child')
                setTimeout(() => { n.style.width = n.offsetWidth + 'px' }, 100)
                setTimeout(() => { n.innerHTML = addName(e) }, 200)
                // n.append(e.abrev)
                i.appendChild(n)
                nr.appendChild(i)
                // add to parent
                p.appendChild(nr)
              } else if (p) {
                // create new col
                let a = p.getElementsByTagName('div')[1]
                let i = document.createElement('div')
                i.className = 'notas-col' + (e.type === 2 ? ' type-descriptive' : '')
                i.id = e.ID
                let n = document.createElement('div')
                n.className = 'notas-name'
                n.id = 'nn-' + e.ID
                if (lasts.indexOf(e.ID) > -1) n.classList.add('notas-last-child')
                setTimeout(() => { n.style.width = n.offsetWidth + 'px' }, 100)
                setTimeout(() => { n.innerHTML = addName(e) }, 200)
                // n.append(e.abrev)
                i.appendChild(n)
                // add parent
                a.appendChild(i)
              }
            }
          });
          index++
        f()
      }
      f()
    }
    // console.log(h)
    return r
  }

  scrollY = () => {
    let element = document.getElementById("notas-header");
    let element2 = document.getElementById("notas-header-pupil");
    let element3 = document.getElementById("notas-right");
    if (!element || !element2 || !element3) return
    if (document.body.scrollTop > 256 || document.documentElement.scrollTop > 256) {
      element3.addEventListener("scroll", (evt) => {
        let x = evt.target.scrollLeft
        // console.log(x)
        element.scrollLeft = x
      }, true)
      let p = element3.getBoundingClientRect();
      // console.log(p.width)
      element.style.width = p.width + 'px'
      element.classList.add("float");
      element.scrollLeft = element3.scrollLeft
      element2.classList.add("float");
    } else {
      element.classList.remove("float");
      element2.classList.remove("float");
    }
  }

  scrollX = (val) => {
    let nr = document.getElementById("notas-right");
    // console.log(nr.offsetWidth)
    let sl = nr.scrollLeft
    let w = nr.offsetWidth * 0.8
    sl = val === 1 ? (sl - w) : (sl + w)
    nr.scroll({ left: sl, behavior: 'smooth' });
    this.setState({selectedArrow: val})
  }

  printTable () {
    let tableToPrint = new ReactToPrint({
    content: () => this.componentRef,
      copyStyles: true,
      bodyClass: 'body-print-custom'
    })
    tableToPrint.handleClick()
  }

  mapGrade(gr) {
    let qualifications = "AD,A,A,B,B,C,C,C";
    if (gr === null) return "";

    gr = Math.round(gr);

    const q = qualifications.split(',');

    const max = q.length;

    if (gr >= 1 && gr <= max) {
        return q[max - gr];
    }

    return "";
  }

  getBorderColor(grade) {
    if (grade === null || grade === undefined) return;
 
    if (typeof grade === 'number') {
      grade = this.mapGrade(grade);
    }

    const gradeColorMap = {
      'AD': 'blue-grade',
      '8': 'blue-grade',
      'A': 'green-grade',
      '7': 'green-grade',
      'B+': 'light-blue-grade',
      '6': 'light-blue-grade',
      'B': 'yellow-grade',
      '5': 'yellow-grade',
      'B-': 'orange-grade',
      '4': 'orange-grade',
      'C': 'red-grade',
      '3': 'red-grade',
      'D': 'brown-grade',
      '2': 'brown-grade',
      'F': 'gray-grade',
      '1': 'gray-grade'
    };

    return gradeColorMap[grade.toString()] || '';
  }

  exportToExcel () {
    if (this.state.evalConcept.length === 0) return
    /* ------- HEADER ------- */
    const header = cloneDeep(this.state.evalConcept)
    header.map(e => {
      e.abrev = e.abrev.toUpperCase()
      e.name = e.name.toUpperCase()
      return e
    })
    let order = []
    var maxLevel = Math.max.apply(Math, header.map(function(o) { return o.level; }));
    // ordeno el array segun level
    for(let i = 0; i<=maxLevel; i++) {
      order = order.concat(header.filter((e) => { return e.level === i }).sort((a, b) => { return a.order - b.order })) // ordeno segun order
    }

    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
    let cols = letters
    let index = 0
    const lastsConcepts = cloneDeep(this.state.lastsConcepts)

    // console.log(lastsConcepts.length, cols.length)

    while (cols.length < lastsConcepts.length) {
      const letter = letters[index]
      cols = cols.concat(letters.map(e => e = letter + e ))
      index++
    }

    // console.log(cols)

    let startCol = 1
    let currentCol = startCol
    let firstColumns = header.filter(e => e.level === 0)
    let cells = {}
    let merges = []
    
    firstColumns.forEach(item => {
      cells[cols[currentCol]+(item.level+1)] = {t: 's', v: item.abrev}
      const search = (item) => {
        order.forEach((e, i) => {
          if (e.parentId === item.ID) {
            let f = order.filter(ee => ee.parentId === item.ID)
            if (f.length > 0 && f[0].ID !== e.ID) currentCol++
            cells[cols[currentCol]+(e.level+1)] = {t: 's', v: e.abrev}
            search(e)
          } else {
            return
          }
        });
      }
      search(item)
      currentCol++
    });

    cells['A'+(maxLevel+1)] = {t: 's', v: 'Alumno'}

    // console.log(cells)
    
    // merges
    for(let l=0; l<=maxLevel; l++) {
      let temp = [] // index cols
      Object.keys(cells).forEach(key => {
        if (key.search(l + 1) > -1) temp.push(cols.indexOf(key.replace(/\d+/g, '')))
      });
      // console.log(temp)
      temp.forEach((c, i) => {
        let p = merges.find(cel => cel.s.r === (l - 1) && c >= cel.s.c && c <= cel.e.c) // level parent
        let ep = 0
        if (p) ep = p.e.c // parent end column
        // console.log(ep)
        merges.push(
          {
            s: {r: l, c: c},
            // e: {r: l, c: (temp[i + 1] ? (temp[i + 1] -1) : c)}
            e: {r: l, c: l === 0 ? ((temp[i + 1] ? (temp[i + 1] -1) : c)) : (temp[i + 1] ? (temp[i + 1] -1) >= ep ? ep : (temp[i + 1] -1) : c)}
          }
        )
      });
    }

    // console.log(merges)
    
    let array = []
    let ws = XLSX.utils.json_to_sheet(array)

    ws = {...ws, ...cells}
    ws['!merges'] = merges
    ws['!ref'] = cols[startCol]+'1:'+cols[currentCol - 1]+(maxLevel + 1)

    for (const i in ws) {
      if (typeof(ws[i]) !== 'object') continue;
      ws[i].s = { // styling for all cells
        alignment: {
          horizontal: 'center'
        },
        font: {
          bold: true
        },
        fill: {
          fgColor: { rgb: 'e7e7e7' }
        }
      };
    }

    // console.log(ws)

    /* ------- STUDENT GRADES ------- */
    const data = cloneDeep(this.state.data)
    let array2 = []
    
    data.forEach((e, i) => {
      array2[i] = {}
      array2[i]['Alumno'] = e.name
      e.grades.forEach(ee => {
        if (ee.gradeNum === null) ee.gradeNum = ''
        if (!ee.gradeTxt) ee.gradeTxt = ''
        array2[i]['ID-' + ee.conceptId] = ee.type === 0 ? ee.gradeNum : ee.gradeTxt 
      });
    })

    ws = XLSX.utils.sheet_add_json(ws, array2, {origin: 'A'+(maxLevel + 2), skipHeader: true})

    for (const i in ws) {
      if (typeof(ws[i]) !== 'object') continue;
      let cell = XLSX.utils.decode_cell(i);
  
      if (!ws[i].s) {
        ws[i].s = { // styling for all cells
          alignment: {
            horizontal: 'center'
          }
        };

        // if (!ws[i].v) ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: 'eae700'}}}}
        if (ws[i].v === 'AD') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: '006699'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'A') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: '66CC66'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'B+') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: '52ebff'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'B') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: 'FFEB3B'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'B-') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: 'FF9900'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'C') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: 'FF6666'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'D') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: '795548'}}, font: {color: {rgb: 'ffffff'}}}}
        else if (ws[i].v === 'F') ws[i].s = {...ws[i].s, ...{fill: {fgColor: {rgb: '9e9e9e'}}, font: {color: {rgb: 'ffffff'}}}}
      }

      if (cell.c === 0) { // first column
        ws[i].s.alignment.horizontal = 'left'
      }
    }

    var wscols = [
      {wch:35} // first column num "characters"
    ];
  
    ws['!cols'] = wscols

    var wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'notas')
    XLSX.writeFile(wb, 'calificaciones.xlsx')
  }

  onChangeAutocomplete = (e) => {
    // console.log(e)
    if (e.value === undefined || e.value === null) return
    this.showDialog({
      title: 'Se perderán las evaluaciones actuales.',
      msg: '¿Está seguro que desea modificar toda la columna?',
      action: (ok) => {
        if (ok) {
          // console.log(this.state.data)
          const {conceptId, type, parentId} = e.params
          const val = e.value
          let items = []
          const data = cloneDeep(this.state.data)
          data.forEach(item => {
            /*
            let g = item.grades.find(e => e.conceptId === conceptId)
            if (g && g.gradeTxt) return
            */
            items.push(
              {
                val: val,
                params: {
                  conceptId: conceptId,
                  studentId: item.studentId,
                  type: type,
                  parentId: parentId
                }
              }
            )
          });
          
          if(items.length > 0) this.edit(items)
        }
      }
    })
  }

  showDialog = (opts) => {
    if(opts){
      this.setState(prevState => {
        let modalGeneric = Object.assign({}, prevState.modalGeneric);
        modalGeneric.title = opts.title
        modalGeneric.msg = opts.msg
        modalGeneric.action = opts.action                  
        return { modalGeneric };                              
      })
    }
    this.setState(prevState => ({
      modalGenericVisible: !prevState.modalGenericVisible
    }), () => { });
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => {
      if (this.state.modal) this.getActivityMasters()
    })
  };

  getActivityMasters = () => {
    this.setState({ mastersProgressBar: true })
    const columns = [
      {
        Header: "Nombre",
        accessor: "name",
      }
    ]

    let filters = {
      alterType: 5,
      superSectionId: this.state.superSectionId,
      sectionId: this.state.sectionId,
      activityId: this.state.activityId,
    }

    filters = objToQueryString(filters)
    _axios
      .get('admActivityMasters/get/?' + filters)
      .then(r => {
        if (r.status >= 0) {
          this.setState({masters: r.data.Results, mastersRowCount: r.data.RowCount, mastersColumns: columns})
        } else NotificationManager.error(r.msg, 'Opps', 5000, null, null, 'outline')
        this.setState({ mastersProgressBar: false })
      })
  }

  static shortcut = (candidate, input) => {
    if (input) {
      const inputValue = input.toLowerCase();
      const candidateValue = candidate.value
      
      switch (inputValue) {
        case 'z':
          return candidateValue === 'AD';
        case 'a':
          return candidateValue === 'A';
        case '+':
          return candidateValue === 'B+';
        case 'b':
          return candidateValue === 'B';
        case '-':
          return candidateValue === 'B-';
        case 'c':
          return candidateValue === 'C';
        case 'd':
          return candidateValue === 'D';
        case 'f':
          return candidateValue === 'F';
        case 's':
          return candidateValue === '';
        default:
          return candidateValue.toLowerCase().startsWith(inputValue);
      }
    }
  
    return true;
  }

  calcularPorAlumno = (studentId, grades) => {
    let body = {
      grades: []
    }

    grades.forEach(e => {
      let item = {conceptId: e.conceptId, gradeTxt: e.gradeTxt, studentId: studentId}
      body.grades.push(item)
    });
    
    _axios
      .post('admGrades/behavior', body)
      .then(r => {
        if (r.status >= 0) {
          NotificationManager.success('', 'CPROM recalculado', 4000, null, null, 'outline')
        } else {
          NotificationManager.error(r.msg, 'No se guardó la nota!', 10000, null, null, 'outline')
        }
      })
      .catch((e) => { })
  }

  calcularPorSeccion = () => {
    let body = {
      grades: []
    }

    this.state.data.forEach(e => {
      let item = {conceptId: e.grades[0].conceptId, gradeTxt: e.grades[0].gradeTxt, studentId: e.studentId}
      body.grades.push(item)
    });

    _axios
      .post('admGrades/behavior', body)
      .then(r => {
        if (r.status >= 0) {
          NotificationManager.success('', 'CPROM recalculado', 4000, null, null, 'outline')
        } else {
          NotificationManager.error(r.msg, 'No se guardó la nota!', 10000, null, null, 'outline')
        }
      })
      .catch((e) => { })
  }

  render() {
    const { locale } = this.props
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx xxs="12" xxl="6">
                {/* TITLE */}
                <h1 className="d-flex align-items-center">
                  { locale === 'es' ? this.view.label : this.view.labelEn }
                  {this.state.data.length > 0 && <i className="simple-icon-refresh pl-3 pointer text-primary" onClick={() => { this.getEvalConcept() }}></i>}
                </h1>
              </Colxx>
              <Colxx xxs="12" xxl="6">
                <div className="d-flex align-items-center flex-wrap justify-content-sm-end justify-content-start mb-3">
                  {/* PRINT */}
                  <Button type="button" color="primary" size="sm" className="mr-2" onClick={() =>  { this.printTable() }}>
                    <i className="simple-icon-printer"></i> Imprimir
                  </Button>

                  {/* EXCEL */}
                  <Button type="button" color="primary" size="sm" className="mr-2" onClick={() =>  { this.exportToExcel() }}>
                    <i className="simple-icon-grid"></i> Excel
                  </Button>
                  
                  {/* ACCIONES EXTRA */}
                  {this.state.ready && this.view.extras && this.view.extras.items && this.view.extras.items.length > 1 &&
                    <div style={{ marginLeft: '-12px' }} className="ml-2">
                      <CustomDropdown 
                        icon="simple-icon-options-vertical" 
                        showMenuOnHover={true}  
                        items={this.view.extras.items}
                        selected={this.state.selectedReport} 
                        addCheck={true}
                      />
                    </div>
                  }

                  {this.state.isBehavior && this.props.userAdmin.ID === 18163 && <Button
                    size="sm"
                    color="primary"
                    onClick={() =>  { this.calcularPorSeccion() }}
                  >
                    Calcular CPROM
                  </Button>
                  /* El boton solo se muestra para un usuario del entorno de producción */
                  }
                </div>
                
                <CustomModal 
                  isOpen={this.state.modal}
                  toggle={this.toggleModal}
                  backdrop={'static'}
                  wrapClassName={'modal-right'}
                  size="lg"
                >
                  <ModalHeader toggle={this.toggleModal}>
                    Profesores
                  </ModalHeader>
                  <ModalBody>
                    <DataTable
                      progressBar={this.state.mastersProgressBar}
                      data={this.state.masters}
                      defaultPageSize={50}
                      columns={this.state.mastersColumns}
                      rowCount={this.state.mastersRowCount}
                      currentPage={1}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button outline color="secondary" size="sm" onClick={() => { this.toggleModal() }}>Cerrar</Button>
                  </ModalFooter>
                </CustomModal>

              </Colxx>
            </Row>
            
            {/* FILTERS */}

            <Form autoComplete="off">
              {this.state.ready && 
                <FormGroup row>
                <Field
                  col="2"
                  name="periodId"
                  label="Periodo"
                  placeholder='[Seleccionar]'
                  value={this.state.periodId}
                  type="select"
                  onChange={(v) => {
                    this.setState({activityId:this.state.activityId, activityReloader: false, masterReloader: false},
                      () => this.setState({activityReloader:true, masterReloader:true}))
                    this.onChangeFieldFilter('periodId', v) 
                 }}
                  opts= {{
                    style: 'float-label',
                    path: "/admPeriod/get?pick=true",
                    setOutput: v => v
                  }}
                />

                {(this.state.periodId && [8,9].indexOf(this.state.selectedReport) > -1) &&
                  <Field
                    col="3"
                    name="groupId"
                    label="Grupo"
                    value={this.state.groupId}
                    type="select"
                    placeholder='[Seleccionar]'
                    onChange={(v) => {
                      this.setState({activityId: null, activityReloader: false, groupId: v},
                        () => this.setState({activityReloader: true}))
                      this.onChangeFieldFilter('groupId', v) 
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admGroup/get?pick=true&staff=" + (this.props.userAdmin.role !== '100' ? '1' : '0') + (this.props.userAdmin.role !== '100' ? '&meIn=true' : '') },
                      setOutput: v => v
                    }}
                  />
                }

                {(this.state.periodId && [8,9].indexOf(this.state.selectedReport) > -1 && this.state.groupId && this.state.activityReloader && !this.state.isBehavior) &&
                  <Field
                    col="3"
                    name="activityId"
                    label="Curso"
                    value={this.state.activityId}
                    type="select"
                    placeholder='[Seleccionar]'
                    onChange={(v) => {
                      this.onChangeFieldFilter('activityId', v)
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admSubject/get?pick=true&periodId=" + this.state.periodId + '&groupId=' + this.state.groupId },
                      setOutput: v => v
                    }}
                  />
                }

                {(this.state.periodId && [2,3,4,5,6].indexOf(this.state.selectedReport) >-1) &&
                  <Field
                    col="3"
                    name="superSectionId"
                    label="Grado"
                    value={this.state.superSectionId}
                    type="select"
                    placeholder='[Seleccionar]'
                    onChange={(v) => {
                      this.setState({sectionId: this.state.sectionId, activityId: this.state.activityId, sectionReloader: false, activityReloader: false, superSectionId: v},
                        () => this.setState({sectionReloader:true, activityReloader: true}))
                      this.onChangeFieldFilter('superSectionId', v) 
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admSuperSection/get?pick=true&periodId=" + this.state.periodId },
                      setOutput: v => v
                    }}
                  />
                }

                {(this.state.periodId && this.state.sectionReloader && this.state.superSectionId && [2,3,4,6].indexOf(this.state.selectedReport) >-1) &&
                  <Field
                    ref={(v)=>(this.sectionId=v)}
                    col="3"
                    name="sectionId"
                    label="Sección"
                    value={this.state.sectionId}
                    type="select"
                    placeholder='[Seleccionar]'
                    onChange={(v) => {
                      if (typeof this.state.activityId  !== 'object' || !this.state.activityId) {
                        this.setState({activityId: null, activityReloader: false, sectionId: v}, () => {
                          this.setState({activityReloader: true})
                          this.onChangeFieldFilter('sectionId', v)
                        } )
                      } else this.onChangeFieldFilter('sectionId', v)
                      
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admSection/get?pick=true&roleFilter=master&parentId=" + this.state.superSectionId + '&periodId=' + this.state.periodId },
                      setOutput: v => v
                    }}
                  />
                }

                {this.state.periodId && this.state.masterReloader && this.state.selectedReport === 1 &&
                  <Field
                    col="4"
                    name="masterId"
                    label="Profesor"
                    value={this.state.masterId}
                    type="select"
                    placeholder='[Seleccionar]'
                    onChange={(v) => { 
                      this.setState({activityId:this.state.activityId, activityReloader: false},
                        () => this.setState({activityReloader:true}))
                      this.onChangeFieldFilter('masterId', v) 
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admStaff/get?type=5&pick=true&filterBy=academic&filter=" + this.state.periodId },
                      setOutput: v => v
                    }}
                  />
                } 

                {this.state.periodId && this.state.activityReloader &&
                ((this.state.superSectionId && this.state.sectionId && (this.state.selectedReport === 2 || this.state.selectedReport === 6))
                || (this.state.superSectionId && this.state.selectedReport === 5)) &&
                  <Field
                    col="3"
                    name="activityId"
                    label="Curso"
                    value={this.state.activityId}
                    type="select"
                    placeholder='[Seleccionar]'
                    onChange={(v) => {
                      if (v && typeof v === 'object') {
                        this.setState({
                          master: v.master || (v.original && v.original.master),
                          masterFace: v.masterFace || (v.original && v.original.masterFace)
                        })
                      }
                      if (this.state.selectedReport === 5) {
                        this.setState({
                          sectionReloader: false,
                          activityId: v,
                        },
                          () => this.setState({sectionReloader:true}))
                      }
                      this.onChangeFieldFilter('activityId', v)
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { 
                        let p = "/admSubject/get?pick=true&periodId=" + this.state.periodId + '&superSectionId=' + this.state.superSectionId + '&sectionId=' + this.state.sectionId
                        return p
                      },
                      setOutput: v => v
                    }}
                  />
                }

                {this.state.periodId && this.state.activityReloader &&
                ((this.state.selectedReport === 1 && this.state.masterId)) &&
                  <Field
                    col="3"
                    name="activityPartId"
                    label="Curso / Sección"
                    value={this.state.activityPartId}
                    type="select"
                    onChange={(v) => { 
                      this.onChangeFieldFilter('activityPartId', v) 
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admSubject/getParts?pick=true&periodId=" + this.state.periodId + '&masterId=' + this.state.masterId },
                      setOutput: v => v
                    }}
                  />
                }

                {(this.state.periodId && this.state.superSectionId && this.state.sectionReloader && [5].indexOf(this.state.selectedReport) > -1 && this.state.activityId) &&
                  <Field
                    col="3"
                    name="sectionId2"
                    label="Sección"
                    value={0}
                    type="select"
                    onChange={(v) => {
                      this.setState({sectionId:v})
                      this.onChangeFieldFilter('sectionId', v)
                    }}
                    opts= {{
                      style: 'float-label',
                      path: () => { return "/admSection/get?pick=true&roleFilter=master&parentId=" + this.state.superSectionId },
                      setOutput: v => v
                    }}
                  />
                }
                </FormGroup>
              }
              
            </Form>
 
          </Colxx>
        </Row>

        {/* GRID */}
        {this.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}
        <Row>
          <Colxx xxs="12">
            {this.state.data.length > 0 &&
              <div className="margin-bottom-60 card fadeIn" ref={el => (this.componentRef = el)}>
                {/* header only for printing */}
                <div className="print-custom-header">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td> <img alt="logo" width="60" className="rounded" src="https://jdblob.blob.core.windows.net/img/comp/santamaria.jpg"/> <b className="ml-2">Reporte de notas</b></td>
                      </tr>
                      <tr>
                        <td>
                          &nbsp;
                        </td>
                      </tr>
                      <tr>
                        <td width="25%" align="center">
                          <b>Periodo:</b> {this.state.labelperiodId}
                        </td>
                        <td width="25%" align="center">
                          <b>Grado/Sección:</b> {this.state.labelsuperSectionId + ' ' + this.state.labelsectionId}
                        </td>
                        <td width="25%" align="center">
                          <b>Curso:</b> {this.state.labelactivityId}
                        </td>
                        <td width="25%" align="center">
                          <b>Profesor:</b> { this.state.labelmasterId || this.state.master || '-' }
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &nbsp;
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="notas">                  
                  <div className="notas-left">
                    <div style={{height: (this.state.numLevels * 24 + 1) + 'px'}}>
                      <div className="notas-spacer" id="notas-header-pupil" style={{height: (this.state.numLevels * 24 + 1) + 'px'}}>
                        {/* <div className="notas-title">Alumno</div> */}
                        <div className="notas-title justify-content-start px-2">
                          <img className="master-face" src={this.state.masterFace ? this.state.masterFace : require("../../../../assets/img/user.png")} onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/user.png")}} alt=""/>
                          <div className="master">Profesor(a): {this.state.master}</div>
                        </div>
                      </div>
                    </div>
                    {/* autocomplete label */}
                    {this.state.data && this.state.data[0].grades.every(e => e.type <= 1) && <div className="notas-item autocomplete-label">
                      <div className="notas-name">Auto completar notas faltantes con:</div>
                    </div>}
                    {/* Stundents */}
                    {this.state.data.map((i, index) => {
                      return (
                        <div className="notas-item" key={index.toString()}>
                          <div className="notas-face">
                            <img src={i.img ? i.img : require("../../../../assets/img/user.png")} onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/user.png")}} alt=""/>
                          </div>
                          <div className="notas-name">{i.name}</div>
                        </div>
                      )})
                    }
                  </div>

                  <div className="notas-right" id="notas-right">
                    <Form autoComplete="off">
                      {/* Header EvalConcept */}
                      <div style={{height: (this.state.numLevels * 24 + 1) + 'px'}}>
                        <div className="notas-header" id="notas-header"></div>
                      </div>
                      
                      {/* Tooltips EvalConcept */}
                      {this.state.showTooltip && this.state.evalConcept.map((i, index) => {
                        return (
                          <UncontrolledTooltip
                            key={index.toString()}
                            placement="top"
                            target={'nn-'+i.ID}>
                            {i.name}
                          </UncontrolledTooltip>
                        )})
                      }

                      {/* Student grades */}
                      <div className="notas-numbers" id="notas-number">

                      {/* autocomplete */}
                      {this.state.data && this.state.data[0].grades.length > 0 && this.state.data[0].grades.every(e => e.type <= 1) &&
                        <div className="notas-row">
                          {this.state.data[0].grades.map((i, index) => {
                            return (
                              <div
                                key={index.toString()}
                                className={"notas-col"}
                              >
                                <Field
                                  col="12"
                                  name={'s-complete-'+index}
                                  value={null}
                                  type="select"
                                  placeholder='-'
                                  onChange={this.onChangeAutocomplete}
                                  disabled={!i.canEdit || i.locked}
                                  tabIndex={index}
                                  params={{inputId: 's-complete-'+index, conceptId: i.conceptId, type: i.type, parentId: i.parentId, calcAverage: i.calcAverage}}
                                  opts={
                                    {
                                      items: i.type === 1 ? i.qualifications : this.state.quantitativeGrades,
                                      isClearable: false,
                                      filterOption: AdmGrades.shortcut
                                    }
                                  }
                                />
                              </div>
                            )
                          })}
                        </div>
                      }
                      
                      {/* grades */}
                      {this.state.data.map((i, index) => {
                        return (
                        <div className="notas-row" key={index.toString()}>
                          {
                            i.grades.map((ii, index2) => {
                              return (
                                <div
                                  key={index2.toString()}
                                  className={"notas-col"+ (ii.type === 2 || ii.type === 4 ? ' type-descriptive' : '')}
                                >
                                  {
                                    ii.locked 
                                    ? 
                                      (
                                        <div>
                                          {!ii.sync && <div className={'border-note ' + this.getBorderColor(ii.type === 1 ? ii.gradeTxt : ii.gradeNum)}></div>}
                                          <button type="button" className="sync-grades text-semi-muted" disabled={!ii.sync || this.state.progressBar} onClick={() => this.getEvalConcept(false) }>
                                            { ii.sync ? <i className={`${this.state.progressBar ? "rotate-icon" : ""}  simple-icon-refresh`}></i> : ii.type === 1 ? ii.gradeTxt : ii.gradeNum }
                                          </button>
                                        </div>
                                      )
                                    : 
                                      (
                                        ii.type === 0 // Quantitative
                                        ?
                                          <div>
                                            <div className={'border-note ' + this.getBorderColor(ii.gradeNum)}></div>
                                            <Field
                                              idParent="grades"
                                              col="12"
                                              name={'n-'+index+'-'+index2}
                                              value={ii.gradeNum !== null && ii.gradeNum !== "" ? ii.gradeNum.toString():null}
                                              type="select"
                                              placeholder= '-'
                                              onChange={this.onChangeField}
                                              onBlur={this.onBlurField}
                                              disabled={!ii.canEdit || ii.locked}
                                              tabIndex={index2}
                                              params={{ inputId: 'n-'+index+'-'+index2, conceptId: ii.conceptId, studentId: i.studentId, type: 0, parentId: ii.parentId, calcAverage: ii.calcAverage }}
                                              opts={
                                                {
                                                  items: this.state.quantitativeGrades,
                                                  isClearable: false,
                                                }
                                              }
                                            />
                                          </div>
                                        : 
                                        ii.type === 1 // Qualitative
                                        ?
                                          <div>
                                            <div className={'border-note ' + this.getBorderColor(ii.gradeTxt)}></div>
                                            <Field
                                              idParent="grades"
                                              col="12"
                                              name={'n-'+index+'-'+index2}
                                              value={ii.gradeTxt?ii.gradeTxt:null}
                                              type="select"
                                              placeholder= '-'
                                              onChange={this.onChangeField}
                                              onBlur={this.onBlurField}
                                              disabled={!ii.canEdit || ii.locked}
                                              tabIndex={index2}
                                              params={{ inputId: 'n-'+index+'-'+index2, conceptId: ii.conceptId, studentId: i.studentId, type: 1, parentId: ii.parentId, calcAverage: ii.calcAverage }}
                                              opts={
                                                {
                                                  items: ii.qualifications,
                                                  isClearable: false,
                                                  filterOption: AdmGrades.shortcut
                                                }
                                              }
                                            />
                                          </div>
                                        : // Free text (type 2 or 4)
                                          <Field
                                            col="12"
                                            name={'n-'+index+'-'+index2}
                                            value={ii.gradeTxt}
                                            type={'text'}
                                            onChange={this.onChangeField}
                                            onBlur={this.onBlurField}
                                            onKeyUp={this.onKeyUpField}
                                            disabled={!ii.canEdit || ii.locked}
                                            placeholder={'Texto libre'}
                                            tabIndex={index2}
                                            params={{ inputId: 'n-'+index+'-'+index2, conceptId: ii.conceptId, studentId: i.studentId, type: ii.type, parentId: ii.parentId }}
                                            maxLength={700}
                                            className={'text-left'}
                                          />
                                      )
                                  }
                                </div>
                              )
                            })
                          }
                          {
                            /*
                            this.state.isBehavior && this.props.userAdmin.ID === 18163 && <div className="d-flex align-items-center justify-content-center">
                              <Button
                                size="sm"
                                color="primary"
                                onClick={() => this.calcularPorAlumno(i.studentId, i.grades)}
                              >
                                Calcular CPROM
                              </Button>
                            </div>
                            // El boton solo se muestra para un usuario del entorno de producción
                            */
                          }
                        </div>
                        )})
                      }
                      </div>
                    </Form>
                  </div>
                </div>

                {/* Scroll X */}
                <div className="btn-scroll-x">
                  <ButtonGroup>
                    <Button
                      size="sm"
                      color="primary"
                      style={{minWidth: 'auto'}}
                      onClick={() => this.scrollX(1)}
                      active={this.state.selectedArrow === 1}
                    >
                      <div className="simple-icon-arrow-left"></div>
                    </Button>
                    <Button
                      size="sm"
                      color="primary"
                      style={{minWidth: 'auto'}}
                      onClick={() => this.scrollX(2)}
                      active={this.state.selectedArrow === 2}
                    >
                      <div className="simple-icon-arrow-right"></div>
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            }
          </Colxx>
        </Row>
        
        {/* MODAL GENERIC */}
        <Dialog
          isOpen={this.state.modalGenericVisible}
          toggle={this.showDialog}
          title={this.state.modalGeneric.title}
          msg={this.state.modalGeneric.msg}
          confirm={(r) => { this.state.modalGeneric.action(r); this.showDialog() }}
        ></Dialog>

      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu;
  const { locale } = settings
  const { deepLink } = utils
  const { userAdmin } = authUser;
  return { locale, menuItems, deepLink, userAdmin };
};

export default connect(mapStateToProps, { setLoader, setDeeplink })(AdmGrades);